import { useGetAllDevicesQuery } from '../features/deviceManagement/deviceApi';
import { useEffect, useState } from 'react';
import { useDebounce } from './useDebounce';
import { usePayloadActions } from './usePayloadActions';

export const useSearchDeviceIds = (callback: any): any => {
    const [inputValue, setInputValue] = useState<any>(null);
    const [, debouncedValue] = useDebounce(undefined, undefined, inputValue);
    const [cleanPayload] = usePayloadActions();
    const { currentData: deviceList, isFetching } = useGetAllDevicesQuery(
        {
            page: 0,
            size: 25,
            filters: { deviceName: debouncedValue },
        },
        { skip: !debouncedValue }
    );

    useEffect(() => {
        if (deviceList?.data && inputValue?.length > 0) {
            callback?.((prev: any) => ({
                ...prev,
                filters: cleanPayload({
                    ...prev?.filters,
                    deviceIds: deviceList?.data?.records?.map((item: any) => item?.id) ?? [],
                }),
            }));
        } else {
            callback?.((prev: any) => ({
                ...prev,
                filters: cleanPayload({
                    ...prev?.filters,
                    deviceIds: [],
                }),
            }));
        }
    }, [deviceList, inputValue]);

    return { inputValue, setInputValue, loading: isFetching };
};
